// extracted by mini-css-extract-plugin
export var heroImage = "post-card-module--heroImage--lT0C2";